import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { VoiceProvider } from '../models/enums/voice-provider';
import { Voice } from '../models/voice';

@Injectable({
  providedIn: 'root'
})
export class VoiceService {

  constructor(private httpClient: HttpClient) { }

  fetchVoices() {
    return this.httpClient.get<Voice[]>(`${environment.voiceUrl}/listAll`);
  }
}
